import React, { useState } from "react";
import { RCCButton, RCCGrid, RCCTooltip } from "react-common-components";
import { Link } from "react-router-dom";
import AppIcons from "src/components/AppIcons";
import DefaultBody from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultBody";
import DefaultContainer from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultContainer";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import useEffectFetchData from "src/hooks/useEffectFetchData";
import { CheckQuadrant, GroupersRisks, RisksSituation } from "src/pages/Risks/Panel/interface";
import { v4 } from "uuid";
import HeaderDashboard from "../../../DefaultDashboardComponents/HeaderDashboard";
import { ICardConfigs, MAX_HEIGHT_LISTS_DASHBOARD } from "../../../interface";
import { IDashboardRisksData } from "../interface";
import Li from "./li";
import * as Styles from "./styles";
import { FilterButton, FilterButtonSelected } from "./styles";

const DashboardListClassificationRisks: React.FC<ICardConfigs> = ({
	card
}) => {
	const { translate } = useTranslation();
	const [dataRisk, setDataRisks] = useState<IDashboardRisksData[]>([]);
	const [filterListQuadrant, setFilterListQuadrant] = useState<CheckQuadrant | undefined>();

	const [totalItenGrouped, setTotalItenGrouped] = useState<{ opportunities: number, thearts: number }>({
		opportunities: 0,
		thearts: 0
	});

	const filterQuadrantRisksOnClickCountBar = (quadrant: CheckQuadrant) => {
		let quadrantToUpdate: CheckQuadrant | undefined = quadrant;
		
		if(filterListQuadrant && filterListQuadrant === quadrant)
			quadrantToUpdate = undefined;
		
		setFilterListQuadrant(quadrantToUpdate);
	};
		
	const {loading} = useEffectFetchData<any> (
		"DashboardRisks/ListRisksClassification", 
		{	quadrant: filterListQuadrant ?? "" },
		({ data }) => {
			if(!filterListQuadrant){
				let totalOpportunities = 0;
				let totalThearts = 0;
				data.forEach((element: any) => {
					totalOpportunities += element.opportunities;
					totalThearts += element.threats;
				});
				setTotalItenGrouped({
					opportunities: totalOpportunities,
					thearts: totalThearts
				});
			}
			setDataRisks(data);
		},
		[filterListQuadrant]
	);
	

	const dataCard = dataRisk && dataRisk.length > 0 ? dataRisk : [{
		classification: translate("Sem classificação"),
		total: 0,
		open: 0,
		closed: 0,
		mediumDegree: 0,
		incidences: 0
	}] as IDashboardRisksData[];

	return (
		<DefaultContainer>
			<HeaderDashboard 
				description={card?.daa002Descricao}
				title={card && card.daa002Titulo.trim().length > 0 ? card.daa002Titulo : translate("Resumo Riscos por Classificação")}
				hexColor={card?.daa002Cor !== null ? card?.daa002Cor : undefined}
				isLoading={loading}
			>
				<RCCGrid container justifyContent="flex-end">
					<RCCTooltip
						text={`${totalItenGrouped.opportunities} ${totalItenGrouped.opportunities > 1 ? translate("oportunidades") : translate("oportunidade")}`}
						color="green"
					>
						<RCCButton 
							color="green" 
							styleInline={filterListQuadrant && filterListQuadrant !== CheckQuadrant.OPPORTUNITY ? FilterButtonSelected : FilterButton}
							onClick={(e) => { e.stopPropagation(); filterQuadrantRisksOnClickCountBar(CheckQuadrant.OPPORTUNITY); }}
						>
					 	{totalItenGrouped.opportunities}	{totalItenGrouped.opportunities > 1 ? translate("oportunidades") : translate("oportunidade")}
						</RCCButton>
					</RCCTooltip>
					<RCCTooltip
						text={`${totalItenGrouped.thearts} ${totalItenGrouped.thearts > 1 ? translate("ameaças") : translate("ameaça")}`}
						color="red"
					>
						<RCCButton 
							color="red" 
							styleInline={filterListQuadrant && filterListQuadrant !== CheckQuadrant.THREAT ? FilterButtonSelected : FilterButton}
							onClick={(e) => { e.stopPropagation(); filterQuadrantRisksOnClickCountBar(CheckQuadrant.THREAT); }}
						>
					 	{totalItenGrouped.thearts}	{totalItenGrouped.thearts > 1 ? translate("ameaças") : translate("ameaça")}
						</RCCButton>
					</RCCTooltip>
					
				</RCCGrid>
				<Link to={`/risks/panel/?group=${GroupersRisks.RISK_CLASSIFICATION}&quadrant=${filterListQuadrant ?? ""}&situation=${RisksSituation.ALL}`}>
					<RCCTooltip
						text={translate("Painel de Riscos")}
						color="grey"
					>
						<RCCButton
							color="transparent"
						>
							<AppIcons 
								name="risks"
								size={14}
							/>
						</RCCButton>
					</RCCTooltip>
				</Link>
				<Link to={`/risks/matrix/?situation=${RisksSituation.ALL}`}>
					<RCCTooltip
						text={translate("Matriz de Riscos")}
						color="grey"
					>
						<RCCButton 
							color="transparent"
							icon={{
								name: "table",
								color: "var(--app-icons-color)"
							}}
						/>
					</RCCTooltip>
				</Link>
			</HeaderDashboard>
			<DefaultBody maxHeight={MAX_HEIGHT_LISTS_DASHBOARD} >
				<>
					<Styles.LiTitles>
						<div />
						<div><RCCTooltip text={translate("Total")} color="purple" position="leftEnd" >{translate("Total")} </RCCTooltip></div>
						<div><RCCTooltip text={translate("Aberto")} color="blue" position="leftEnd">{translate("Aberto")} </RCCTooltip></div>
						<div><RCCTooltip text={translate("Finalizado")} color="green" position="leftEnd">{translate("Finalizado")} </RCCTooltip></div>
						<div><RCCTooltip text={translate("Grau médio")} color="grey" position="leftEnd">{translate("Grau médio")} </RCCTooltip></div>
						<div><RCCTooltip text={translate("Incidências")} color="red" position="leftEnd">{translate("Incidências")} </RCCTooltip></div>
					</Styles.LiTitles>

					{dataCard && dataCard.map((item) => (
						<React.Fragment key={v4()}>
							<Styles.LiPanelBodyContent>
								<div>
									<Title color="purple" size="sm">
										{item.classification}
									</Title>
								</div>
								 <Li data={item} filterListQuadrant={filterListQuadrant} />
								 </Styles.LiPanelBodyContent>
						</React.Fragment>
					))}
				</>
			</DefaultBody>	
		</DefaultContainer>
	);
};

export default DashboardListClassificationRisks;
